import { getCategory } from '@/api/system'

const state = {
  categories: []
}
const mutations = {
  SET_CATEGORIES: (state, categoryData) => {
    state.categories = categoryData || []
  }
}

const actions = {
  // user login
  getCategoryAction ({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      getCategory().then(response => {
        const { data } = response
        console.log('这里调用了 action 222' + data)
        commit('SET_CATEGORIES', data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
